import { render } from "./OncologyVisitModal.vue?vue&type=template&id=7924c901&scoped=true"
import script from "./OncologyVisitModal.vue?vue&type=script&lang=js"
export * from "./OncologyVisitModal.vue?vue&type=script&lang=js"

import "./OncologyVisitModal.vue?vue&type=style&index=0&id=7924c901&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7924c901"]])

export default __exports__